import React, { useEffect, memo } from "react";
import { ENV } from "../../env";

const ReCaptcha = (props) => {
    const { onComplete, regenerate } = props;

    useEffect(() => {
        if (regenerate) {
            const loadScriptByURL = (id, url, callback) => {
                const isScriptExist = document.getElementById(id);
                if (!isScriptExist) {
                    const script = document.createElement("script");
                    script.type = "text/javascript";
                    script.src = url;
                    script.id = id;
                    script.async = true;
                    script.defer = true;
                    script.onload = function () {
                        if (callback) callback();
                    };
                    document.body.appendChild(script);
                } else if (callback) {
                    callback();
                }
            };

            loadScriptByURL(
                "recaptcha-key",
                `https://www.google.com/recaptcha/api.js?render=${ENV["captcha"]}`,
                function () {
                    // بررسی می‌کنیم که grecaptcha در دسترس است
                    if (window.grecaptcha) {
                        window.grecaptcha.ready(() => {
                            window.grecaptcha
                                .execute(ENV["captcha"], { action: "submit" })
                                .then((token) => {
                                    onComplete(token);
                                })
                                .catch((error) => {
                                    console.error("Error executing recaptcha:", error);
                                });
                        });
                    } else {
                        console.error("window.grecaptcha is undefined after script load.");
                    }
                }
            );
        }
    }, [regenerate, onComplete]);

    return null;
};

export default memo(ReCaptcha);
